import { render, staticRenderFns } from "./UnshippedDetailsImport.vue?vue&type=template&id=0f6984df&scoped=true&"
import script from "./UnshippedDetailsImport.vue?vue&type=script&lang=js&"
export * from "./UnshippedDetailsImport.vue?vue&type=script&lang=js&"
import style0 from "./UnshippedDetailsImport.vue?vue&type=style&index=0&id=0f6984df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6984df",
  null
  
)

export default component.exports